import React from 'react'

export const Facebook = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9155 13.0416L16.3714 10.1448H13.5628V8.26179C13.5628 7.46968 13.9549 6.69567 15.2088 6.69567H16.5036V4.22881C15.7496 4.10857 14.9876 4.04351 14.2239 4.03418C11.9123 4.03418 10.4032 5.42377 10.4032 7.93589V10.1448H7.84082V13.0416H10.4032V20.0484H13.5628V13.0416H15.9155Z"
      fill="#9AA5B8"
    />
  </svg>
)
